import axios from 'axios';
import { getClientToken } from './clientCookie';

const axiosInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Improved token handling in interceptor
axiosInstance.interceptors.request.use(async (config) => {
  try {
    // Try to get token from auth storage first
    const authStorage = localStorage.getItem('auth-storage');
    let token = null;

    if (authStorage) {
      const parsedStorage = JSON.parse(authStorage);
      token = parsedStorage?.state?.token;
      // console.log('Token from storage:', token); // Debug
    }

    // If no token in storage, try cookie
    if (!token) {
      token = getClientToken();
      // console.log('Token from cookie:', token); // Debug
    }

    // If we have a token from either source, use it
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      // console.log('Setting auth header:', `Bearer ${token}`); // Debug
    }
  } catch (error) {
    console.error('Error setting auth header:', error);
  }
  return config;
});

// Add response interceptor to handle 401s more gracefully
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Only clear storage and redirect if it's a true auth failure
      // Check if the error is from a specific endpoint that indicates auth failure
      if (error.config.url.includes('/auth/') || error.config.url.includes('/users/me')) {
        localStorage.removeItem('auth-storage');
        window.location.href = '/ar/auth/login';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
